import { Skeleton, SkeletonText } from '@/components/ui';
import './PageFallback.css';

/**
 * Suspense fallback for lazily-loaded routes. Content-shaped (header + table
 * rows), never a centered spinner, so the page transition reads as the page
 * arriving rather than a blank flash.
 */
export function PageFallback(): JSX.Element {
  return (
    <div className="page-fallback" aria-busy="true" aria-label="Carregando página">
      <div className="page-fallback__header">
        <Skeleton width={220} height="1.75rem" />
        <Skeleton width={360} height="0.9rem" />
      </div>
      <div className="page-fallback__block">
        <SkeletonText lines={2} />
      </div>
      <div className="page-fallback__rows">
        {Array.from({ length: 6 }, (_, i) => (
          <Skeleton key={i} height="2.5rem" />
        ))}
      </div>
    </div>
  );
}
